<div class="main" style="overflow:auto;">
    <table id="facilityTable">
        <thead>
            <tr style="pointer-events: none;" id="tableHeader">
                <th *ngFor="let columnObj of columnList" [ngStyle]="{'text-align': columnObj?.textAlign == 'start' ? 'start' : columnObj?.textAlign, 
                'padding-left': columnObj?.paddingLeft ? columnObj?.paddingLeft : ''}">
                    {{columnObj.name}}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let obj of tableData; let index=index">
                <td style="width: 100px;">
                    {{(currentPage-1) * 10 + index+1}}
                </td>
                <td *ngIf="tableFor == 'facilityList'"
                    style="width:250px; padding-left:30px; color: #ED1556; cursor:pointer; font-weight:600; text-align:start;"
                    (click)="facilityNameClick(obj.id)">
                    {{(obj?.facility_name !== "" && obj?.facility_name != null && obj?.facility_name != undefined)
                    ? obj?.facility_name
                    : 'N/A'}}
                </td>
                <!-- <td *ngIf="tableFor == 'facilityList'" style="width:250px; text-align:start;">
                    {{obj?.cse_name}}
                </td> -->

                <td *ngIf="tableFor == 'facilityList'" style="width:10px; text-align:start;">
                    {{(obj?.state_name !== "" && obj?.state_name !== null && obj?.state_name !== undefined)
                    ? obj?.state_name
                    : 'N/A'}}
                </td>

                <td *ngIf="tableFor == 'facilityList'"
                    style="display: flex; align-items:center; justify-content:center;">
                    <div
                        style="background: #19B1230D; width:fit-content; color:#19B123;  border-radius:14px; padding:5px 24px">
                        Registration
                    </div>
                </td>

                <td *ngIf="tableFor == 'facilityList'">
                    ₹ {{obj?.total_paid_amount !== null ? obj?.total_paid_amount : 0}}
                </td>

                <td *ngIf="tableFor == 'facilityList'">
                    {{
                    (obj?.is_payment == true) ? 'Completed' :
                    (obj?.overall_payment_status == '1') ? 'Pending For Approval' :
                    (obj?.is_payment == false && obj?.overall_payment_status == '2') ? 'PartiallyCompleted' :
                    (obj?.is_payment == false && obj?.overall_payment_status == '3') ? 'Rejected' : 
                    'Pending'
                    }}
                </td>

                <td *ngIf="tableFor == 'facilityList'" style="width:180px;"
                    [ngStyle]="{'color' : obj?.profilePercentage == '100' ? '#19B123': obj?.profilePercentage < '100' && obj?.profilePercentage >'30' ? '#F09329' : '#D60F0F', 'font-weight': 600}">
                    {{(obj?.profilePercentage !== "" && obj?.profilePercentage !== null && obj?.profilePercentage !==
                    undefined)
                    ? (obj?.profilePercentage + '%')
                    : 'N/A'}}
                </td>

                <td *ngIf="tableFor == 'cseList'"
                    style="width:250px; padding-left:30px; font-weight:600; text-align:start;">
                    {{(obj?.name !== "" && obj?.name !== null && obj?.name !== undefined)
                    ? obj?.name
                    : 'N/A'}}
                </td>

                <td *ngIf="tableFor == 'cseList'"
                    style="width:250px; padding-left:15px; font-weight:600; text-align:start;">
                    {{(obj?.lead_dr_name !== "" && obj?.lead_dr_name !== null && obj?.lead_dr_name !== undefined)
                    ? obj?.lead_dr_name
                    : 'N/A'}}
                </td>

                <td *ngIf="tableFor == 'cseList'" style="width:250px; padding-left:60px; font-weight:600; ">
                    <div class="activeInactive"
                        [ngStyle]="{'background': obj?.status == 1 ? '#19B1230D' : 'rgb(255, 232, 232)', 'color' : obj?.status == 1 ? '#19B123' : '#D60F0F'}">
                        {{(obj?.status !== "" && obj?.status !== null && obj?.status !== undefined)
                        ? obj?.status == 1 ?'Active' : 'Inactive'
                        : 'N/A'}}
                    </div>
                </td>

                <td *ngIf="tableFor == 'cseMapped'" (click)="goToCseFacilityMapped(obj?.cseId)"
                    style="width:200px; padding-left:30px; color: #ED1556; cursor:pointer; font-weight:600; text-align:start;">
                    {{(obj?.cse_name !== "" && obj?.cse_name !== null && obj?.cse_name !== undefined )
                    ? obj?.cse_name
                    : 'N/A'}}
                </td>

                <td *ngIf="tableFor == 'cseMapped'"
                    style="width:200px; padding-left: 80px; font-weight:600; text-align:start;">
                    {{(obj?.userCount !== "" && obj?.userCount !== null && obj?.userCount !== undefined)
                    ? obj?.userCount
                    : 'N/A'}}
                </td>

                <td *ngIf="tableFor == 'cseMapped'" (click)="editCSEProfile(obj?.cseId)"
                    style="width:250px; padding-left:25px; font-weight:600; cursor:pointer;">
                    <i class="fa fa-pencil-square-o" style="color:#ED1556 ;" aria-hidden="true"></i>
                </td>

                <td *ngIf="tableFor == 'cseFacilityMapped'"
                    style="width:250px; padding-left:30px; font-weight:600; text-align:start;">
                    {{(obj?.cseName !== "" && obj?.cseName !== null && obj?.cseName !== undefined)
                    ? obj?.cseName
                    : "N/A"}}
                </td>

                <td *ngIf="tableFor == 'cseFacilityMapped'" style="width:200px;  font-weight:600; text-align:start;">
                    {{(obj?.facility_name !== "" && obj?.facility_name !== null && obj?.facility_name !== undefined)
                    ? obj?.facility_name
                    : 'N/A'}}
                </td>

                <!-- <td *ngIf="tableFor == 'cseFacilityMapped'"
                    (click)="editCSEProfile(obj?.cseId, obj?.users?.id)"
                    style="width:250px; padding-left:25px; font-weight:600; cursor:pointer;">
                    <i class="fa fa-pencil-square-o" style="color:#ED1556 ;" aria-hidden="true"></i>
                </td> -->

                <td *ngIf="tableFor == 'cseList'" (click)="editAddCseForm(obj?.id)"
                    style="width:250px; padding-left:25px; font-weight:600; cursor:pointer;">
                    <i class="fa fa-pencil-square-o" style="color:#ED1556 ;" aria-hidden="true"></i>
                </td>
            </tr>
        </tbody>
    </table>

    <div *ngIf="(tableData && tableData.length < 1) && this.spinnerService.dataFound$ | async" class="noDataText">
        <div style="display: flex; flex-direction:column; align-items:center;">
            <!-- No Data Found -->
            <img src="assets/images/no-data-found.svg" alt="No Data Found" width="250px" height="250px">
            <div class="noData">No Data Found</div>
        </div>
    </div>

    <div [ngClass]="tableData.length < 8 ? 'pagination2' : 'pagination1'">
        <div style="display: flex;">
            <div class="pagiInfo">
                <span>Showing results </span>{{(currentPage-1) * 10 + 1}} - {{(currentPage-1) * 10 + tableData.length}}<span></span> of <span>{{totalReceiveData}}</span>
            </div>
            <ngb-pagination [collectionSize]="totalReceiveData" maxSize="5" (pageChange)="handlePagination($event)"
                [(page)]="currentPage" [boundaryLinks]="true">
            </ngb-pagination>
        </div>
    </div>

</div>